import { useContext } from 'react';
import { LineSubject as BaseLineSubject } from '@visx/annotation';
import DataContext from "../../context/DataContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
/** AnnotationLineSubject which provides color and dimensions from context. */
export default function AnnotationLineSubject(_ref) {
  let {
    min,
    max,
    ...props
  } = _ref;
  const {
    theme,
    margin,
    innerHeight = 0,
    innerWidth = 0
  } = useContext(DataContext);
  return /*#__PURE__*/_jsx(BaseLineSubject, {
    stroke: theme?.axisStyles.x.bottom.axisLine.stroke,
    min: min ?? (props.orientation === 'horizontal' ? margin?.left : margin?.top) ?? 0,
    max: max ?? (props.orientation === 'horizontal' ? (margin?.left ?? 0) + innerWidth : (margin?.top ?? 0) + innerHeight),
    ...props
  });
}